import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { ctfCommonMessages } from "./common";
import { ctfAuthPageMessages } from "./pages-auth";
import { ctfDashboardPageMessages } from "./pages-dashboard";
import { ctfCategoryPageMessages } from "./pages-categories";
import { ctfChallengePageMessages } from "./pages-challenges";
import { ctfArtifactReleasePageMessages } from "./pages-artifact-releases";

const CTF_LOCALES = ["zh-CN", "en", "ja"] as const satisfies readonly AppLocale[];

const ctfCatalogSlices: Array<Record<AppLocale, MessageTree>> = [
  ctfCommonMessages,
  ctfAuthPageMessages,
  ctfDashboardPageMessages,
  ctfCategoryPageMessages,
  ctfChallengePageMessages,
  ctfArtifactReleasePageMessages,
];

function cloneMessageValue(value: string | MessageTree): string | MessageTree {
  if (typeof value === "string") {
    return value;
  }
  return mergeMessageTree({}, value);
}

function mergeMessageTree(target: MessageTree, source: MessageTree): MessageTree {
  Object.entries(source).forEach(([key, value]) => {
    const existing = target[key];
    if (value && typeof value === "object" && existing && typeof existing === "object") {
      target[key] = mergeMessageTree(existing, value);
      return;
    }
    target[key] = cloneMessageValue(value);
  });
  return target;
}

export const ctfMessages = Object.fromEntries(
  CTF_LOCALES.map((locale) => [
    locale,
    ctfCatalogSlices.reduce<MessageTree>(
      (messages, slice) => mergeMessageTree(messages, slice[locale]),
      {},
    ),
  ]),
) as Record<AppLocale, MessageTree>;
